/* eslint-disable react/jsx-props-no-spreading */
import { render } from 'react-dom';
import React from 'react';
import { Globals } from '@bwoty-web/ui-kit';

import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import { GTMLoggerMiddleware } from './redux/middleware/gtmLoggerMiddleware';
import priceOfferListApp from './redux/reducers/priceOfferList';
import PriceOfferListContainer from './components/priceOfferList/priceOfferListContainer';

const initialStateList = [];
Object.keys(window).forEach((key) => {
  if (key.startsWith('__INITIAL_STATE_PRICE_OFFER_LIST_')) {
    initialStateList.push(window[key]);
    delete window[key];
  }
});

if (initialStateList.length > 0) {
  initialStateList.forEach((initialState) => {
    const priceOfferListStore = createStore(
      priceOfferListApp,
      applyMiddleware(thunk, GTMLoggerMiddleware),
    );
    render(
      <Provider store={priceOfferListStore}>
        <Globals siteId={initialState.siteId}>
          <PriceOfferListContainer {...initialState} />
        </Globals>
      </Provider>,
      document.getElementById(`po-list-app-root-${initialState.uniqueId}`),
    );
  });
}